export default __webpack_public_path__ + "static/media/lista.18642f98.png";